import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { LinkModule } from "@lantern/app/common/link";
import { IconModule } from "@lantern/app/common/utils";
import { BoxModule } from "../box";
import { FlexBoxModule } from "../flex-box";
import { ButtonComponentModule } from "../forms/button";
import { PageContainerComponentModule } from "../page-container";
import { SidebarComponentModule } from "../sidebar/sidebar-component.module";
import { DetailPageComponent } from "./detail-page.component";

@NgModule({
  imports: [
    CommonModule,

    BoxModule,
    ButtonComponentModule,
    FlexBoxModule,
    PageContainerComponentModule,
    IconModule,
    LinkModule,
    SidebarComponentModule
  ],
  declarations: [DetailPageComponent],
  exports: [DetailPageComponent]
})
export class DetailPageComponentModule {}
